import { render } from "./Embrio.vue?vue&type=template&id=22174170"
import script from "./Embrio.vue?vue&type=script&lang=js"
export * from "./Embrio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__